module.exports = __webpack_public_path__ + "static/media/pointer_mobile.44dc1256.svg";